import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://groups-service-shadow.onyxcentersource.com',
  hostname: 'groups-shadow.onyxcentersource.com',
  portalUrl: 'https://portal.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd.service.onyxcentersource.com/api',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.app.onyxcentersource.com',

  emailValidation: true,

  logServices: {
    consoleLogSubscriber: {
      logLevel: 2
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  },
  cwr: {
    enable: true
  },
  agencyDashboardUrl: 'https://agency-dashboard.service.onyxcentersource.com',
  showAgencyDashboard: false
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.prodShadow.ts